/**
 * Vitrine: os módulos da plataforma que uma conta do Otto vê com cadeado e pode conhecer (docs/specs/otto/TDD.md §4.2, §6;
 * docs/specs/otto/VITRINE.md).
 *
 * Cada módulo diz qual recurso do plano o libera (`feature`) e qual item do catálogo de navegação ele é (`navKey`,
 * `packages/shared/platform/navigation.js`): o cadeado leva ao endereço real do módulo, e é nesse endereço que a vitrine
 * aparece no lugar da tela. O texto de cada página mora em `content/<modulo>.js` (dados puros, sem JSX).
 */
import inbox from './content/inbox.js';
import crm from './content/crm.js';
import reports from './content/reports.js';
import automation from './content/automation.js';
import otto from './content/otto.js';

const BASE = [
    { key: 'inbox', navKey: 'inbox', feature: 'inbox.enabled' },
    { key: 'crm', navKey: 'crm', feature: 'crm.enabled' },
    { key: 'reports', navKey: 'reports', feature: 'reports.basic' },
    { key: 'automation', navKey: 'automation', feature: 'automations.enabled' },
    // O Otto não é item da barra (`navKey: null`): a vitrine dele aparece dentro da Inbox, para quem não tem o Otto.
    { key: 'otto', navKey: null, feature: 'calling.video' },
];

const CONTENT = { inbox, crm, reports, automation, otto };

export const SHOWCASE_MODULES = Object.freeze(
    BASE.map((base) => {
        const content = CONTENT[base.key];
        return Object.freeze({ ...base, ...content, headline: content.heroTitle.join(' ') });
    }),
);

/** @param {string} key @returns {object | null} */
export const showcaseModule = (key) => SHOWCASE_MODULES.find((m) => m.key === key) ?? null;

/** @param {string} navKey chave do item no catálogo de navegação @returns {object | null} */
export const showcaseModuleByNavKey = (navKey) => (navKey ? SHOWCASE_MODULES.find((m) => m.navKey === navKey) ?? null : null);
